import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SkupinaSlevMaterialu = {
	name: NAME,
	apiProvider,
	router,
};
